import * as yup from 'yup';

export const schema = yup
  .object({
    name: yup.string().optional(),
    value: yup.string(),
    label: yup.string(),
  })
  .transform(value => ({
    name: value.name,
    value: value.value,
    label: value.label,
  }));
